/* Forces the Rebuy cart progress bar into its "qualified" state when a free-shipping override variant is in cart. */
(function () {
  var settings = window.freeShippingOverrides;
  if (!settings || !settings.enabled) return;

  var variantIds = (settings.variantIds || [])
    .map(function (id) {
      return String(id).trim();
    })
    .filter(Boolean);

  if (!variantIds.length) return;

  var WRAPPER_SELECTOR = '.rebuy-cart__progress-bar-wrapper';
  var FILL_SELECTOR = '.rebuy-cart__progress-bar-meter-fill';
  var PROMPT_SELECTOR = '.rebuy-cart__progress-bar-prompt';

  var cartQualifies = false;
  var applyingOverride = false;

  function cartHasOverrideVariant(cart) {
    return (cart.items || []).some(function (item) {
      return variantIds.indexOf(String(item.variant_id)) !== -1;
    });
  }

  function isAlreadyApplied(fill, prompt) {
    return (
      fill &&
      fill.style.width === '100%' &&
      prompt &&
      prompt.innerHTML === settings.message
    );
  }

  function applyOverride() {
    if (!cartQualifies) return;

    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;

    var bar = wrapper.querySelector('[role="progressbar"]');
    var fill = wrapper.querySelector(FILL_SELECTOR);
    var prompt = wrapper.querySelector(PROMPT_SELECTOR);

    if (isAlreadyApplied(fill, prompt)) return;

    applyingOverride = true;
    if (bar) bar.setAttribute('aria-valuenow', '100');
    if (fill) fill.style.width = '100%';
    if (prompt) prompt.innerHTML = settings.message;
    applyingOverride = false;
  }

  function refreshCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cartQualifies = cartHasOverrideVariant(cart);
        applyOverride();
      })
      .catch(function () {});
  }

  // Rebuy re-renders the progress bar asynchronously, so watch for it and re-apply the override.
  var observer = new MutationObserver(function () {
    if (applyingOverride) return;
    applyOverride();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  });

  // Re-check the cart whenever a cart-related request (add/change/update) resolves.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var result = originalFetch.apply(this, arguments);
    var request = arguments[0];
    var url = request && request.url ? request.url : request;
    if (typeof url === 'string' && url.indexOf('/cart') !== -1) {
      result.then(function () {
        setTimeout(refreshCartState, 300);
      });
    }
    return result;
  };

  document.addEventListener('DOMContentLoaded', refreshCartState);
  refreshCartState();
})();
